import ServiceStatusTable from './ServiceStatusTable.vue';
export default ServiceStatusTable;
